import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {Container, Dropdown, Grid, Header, Icon, Input, Menu} from 'semantic-ui-react';
import FilterBar, {propShape as FilterBarPropShape} from 'components/common/FilterBar';
import ItemTable, {propShape as ItemTablePropShape} from 'components/common/ItemTable';
import ItemGrid, {propShape as ItemGridPropShape} from 'components/common/ItemGrid';
import PagingBar, {propShape as PagingBarPropShape} from 'components/common/PagingBar';
import {clone, ItemExplorerViewOptions, ItemExplorerViewOptionsPropType} from "utils/DBUtils";
import {EmptyFunc} from "../../utils/DBUtils";

/**
 * Standard component for displaying a paginated view as a list or grid.
 *
 * Uses PagingBar for pagination
 *
 * Uses ItemTable for table display
 *
 * Uses ItemGrid for grid display
 *
 */
const ItemExplorer = (props) => (
    <React.Fragment>
      {!props.itemsOnly && (
        <Grid columns={2} className="db-item-explorer">
          <Grid.Row>
            <Grid.Column width={12}>
              <Header as="h1">{props.header}</Header>
              <p>{props.description}</p>
            </Grid.Column>
            <Grid.Column width={4} className="db-break-control db-item-explorer">
              <Container textAlign="center">
                <Header as="h3">{props.header}</Header>
                <Menu.Item onClick={props.onViewToggled}>
                  {props.showView === ItemExplorerViewOptions.List ? "Card " : "List "} View
                </Menu.Item>
                <br/>
                {props.actions.map((Item, index) => <Item key={index} />)}
              </Container>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      )}
      {!props.filterBarProps.hidden && <FilterBar {...props.filterBarProps} />}
      {props.showView === ItemExplorerViewOptions.List ? (
        <div className={classnames('item-explorer-table-container', {scrolling: props.tableProps.scrolling})}>
          <ItemTable {...props.tableProps} />
        </div>
      ) : (
        <ItemGrid {...props.gridProps} />
      )}
      <PagingBar {...props.pagingBarProps} />
    </React.Fragment>
);

ItemExplorer.propTypes = {
    header: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    actions: PropTypes.arrayOf(PropTypes.func),
    showView: ItemExplorerViewOptionsPropType.isRequired,
    itemsOnly: PropTypes.bool,
    /**
     * Props that will be passed to nested ItemGrid
     * @see ItemGrid
     */
    gridProps: PropTypes.shape(clone(ItemGridPropShape)).isRequired,
    /**
     * Props that will be passed to nested ItemTable
     * @see ItemTable
     */
    tableProps: PropTypes.shape(clone(ItemTablePropShape)).isRequired,
    /**
     * Props that will be passed to nested PagingBar
     * @see PagingBar
     */
    pagingBarProps: PropTypes.shape(clone(PagingBarPropShape)).isRequired,
    filterBarProps:  PropTypes.shape(FilterBarPropShape).isRequired,
    onViewToggled: PropTypes.func
};

ItemExplorer.defaultProps = {
    actions: [],
    itemsOnly: false,
    onFilterSelected: EmptyFunc,
    onFilterDeselected: EmptyFunc
};

export default ItemExplorer;



// WEBPACK FOOTER //
// ./public/components/common/ItemExplorer.jsx